import { render, staticRenderFns } from "./SleepViewWelcome.vue?vue&type=template&id=59518e3d"
import script from "./SleepViewWelcome.vue?vue&type=script&lang=js"
export * from "./SleepViewWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports